export interface RateItem {
  type: string;
  icon: string;
  unit: string;
  range: string;
  base: string;
  note: string;
}

export const rateItems: RateItem[] = [
  {
    type: "图文瓜料",
    icon: "ri-file-text-line",
    unit: "元 / 篇",
    range: "20 ~ 200",
    base: "基础稿费 20",
    note: "有图有真相、条理清晰的瓜料按篇结算，字数与证据越多越值钱。",
  },
  {
    type: "独家视频",
    icon: "ri-vidicon-line",
    unit: "元 / 条",
    range: "50 ~ 800",
    base: "基础稿费 50",
    note: "实拍、监控、现场一手画面溢价明显，清晰度与真实性直接影响单价。",
  },
  {
    type: "热点线索",
    icon: "ri-flashlight-line",
    unit: "元 / 条",
    range: "10 ~ 100",
    base: "基础稿费 10",
    note: "尚未发酵但可能成为热议方向的新鲜线索，先手越快越值钱。",
  },
  {
    type: "深度整料",
    icon: "ri-focus-3-line",
    unit: "元 / 篇",
    range: "100 ~ 1000",
    base: "基础稿费 100",
    note: "多角度拼接、时间线完整、含独家证据的深度瓜料单价最高。",
  },
];

export interface FactorItem {
  title: string;
  desc: string;
  icon: string;
}

export const factorItems: FactorItem[] = [
  {
    title: "独家与稀缺",
    desc: "全网首个爆出、没有第二家有的料，溢价空间最大，平台抢着要。",
    icon: "ri-gemini-line",
  },
  {
    title: "真实与证据",
    desc: "截图、录音、实拍等可核验证据越扎实，稿费越敢往上给。",
    icon: "ri-checkbox-circle-line",
  },
  {
    title: "热度与话题",
    desc: "契合当下吃瓜风向、自带讨论度的瓜，更容易被提价录用。",
    icon: "ri-fire-line",
  },
  {
    title: "时效与首发",
    desc: "抢在别人前面、反应越快的料，单价往往翻着涨。",
    icon: "ri-time-line",
  },
];

export interface StepItem {
  step: string;
  title: string;
  desc: string;
}

export const flowSteps: StepItem[] = [
  {
    step: "01",
    title: "挑选靠谱渠道",
    desc: "优先看明确写清稿费标准、结算周期与提现门槛的平台，避开只画饼的坑。",
  },
  {
    step: "02",
    title: "整理素材证据",
    desc: "把时间线、关键截图、可验证来源理清楚，证据链越完整越好卖。",
  },
  {
    step: "03",
    title: "提交过审",
    desc: "按平台栏目要求提交，等待审核定级，保留好审核回执或录用通知。",
  },
  {
    step: "04",
    title: "确认稿费",
    desc: "录用后核对单价与分成，确认无误再放行，别让口头承诺落空。",
  },
  {
    step: "05",
    title: "结算提现",
    desc: "按结算周期到期后提现，看清起提金额、手续费与到账时间。",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: "吃瓜投稿真的能赚钱吗？",
    a: "能，但前提是你要有真材实料。真正能变现的是独家、有证据、契合热点的内容，随手转发的旧瓜基本没人付费。稿费单价从几元到上千元不等，更多考验的是你的料够不够硬。",
  },
  {
    q: "一条瓜到底能卖多少钱？",
    a: "行业里没有统一价，通常图文瓜料在 20~200 元/篇，独家视频 50~800 元/条，深度整料可到百元甚至上千元。单价主要看独家性、证据完整度和话题热度，越稀缺越值钱。",
  },
  {
    q: "稿费多久结算一次？",
    a: "常见的是按周或按月结算，录用并通过发布后才进入结算流程。各家周期不同，投稿前一定要看清结算规则，确认是人工转账还是平台钱包提现。",
  },
  {
    q: "提现有门槛吗？",
    a: "多数平台设了起提金额，比如满 10 元、50 元或 100 元才能提。提现可能按笔收少量手续费，部分还要求实名认证，到账多为 1~3 个工作日。",
  },
  {
    q: "没有证据的瓜能投稿吗？",
    a: "不建议。缺乏可核验证据的料通常审核不通过，就算录用了也容易因真实性不足被追回稿费甚至封号。投稿前先确认证据链完整，对自己也是保护。",
  },
  {
    q: "如何判断平台给的价格合理？",
    a: "可以横向对比几家平台的公开价目表，看同类型料的区间是否接近；更要警惕先交保证金、押金才结算的套路，这类往往不靠谱。",
  },
];

export interface TipItem {
  icon: string;
  title: string;
  desc: string;
}

export const tipItems: TipItem[] = [
  {
    icon: "ri-spam-line",
    title: "警惕先交钱的套路",
    desc: "正规投稿基本不会让你先交保证金或押金，凡是要先付费的渠道果断绕开。",
  },
  {
    icon: "ri-shield-keyhole-line",
    title: "保护自身隐私",
    desc: "投稿用化名和专用邮箱，不暴露能定位到自己的身份信息，收钱与爆料分离。",
  },
  {
    icon: "ri-scales-3-line",
    title: "守住法律底线",
    desc: "不投稿捏造诽谤、侵犯隐私的内容，涉及他人肖像与隐私时务必谨慎。",
  },
  {
    icon: "ri-bookmark-3-line",
    title: "留存往来凭证",
    desc: "录用通知、单价确认、结算记录都留档，出现纠纷时有据可依。",
  },
];

export interface StatItem {
  num: string;
  label: string;
  sub: string;
}

export const statItems: StatItem[] = [
  { num: "200+", label: "投稿栏目类型", sub: "图文 / 视频 / 线索" },
  { num: "3", label: "主流结算周期", sub: "周结 / 月结 / 即时" },
  { num: "24h", label: "常见审核时长", sub: "过审后可定级" },
  { num: "1~3", label: "提现到账工作日", sub: "节假日顺延" },
];